
import {library} from "@fortawesome/fontawesome-svg-core";
import {faGoogleDrive} from "@fortawesome/free-brands-svg-icons/faGoogleDrive";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import * as React from "react";

import {observable} from "mobx";
import {EventManager} from "shared/utilities/Events/EventManager";
import {ItemDeleted} from "PageBuilder/Events/ItemDeleted";
import {PageSectionOptions, PaperSize} from "PageBuilder/dto/Options";
import {ConfirmDialog} from "PageBuilder/utils/Dialogs/ConfirmDialog";
import {SectionDragManager} from "PageBuilder/pagebuilder/util/SectionDragManager";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {
    BackgroundStyleEnum,
    PageOptions,
    PDFDocumentOptions,
    SectionOption,

} from "PageBuilder/pagebuilder/PDFDocument.Options";

import {PageService} from "PageBuilder/pagebuilder/services/PageService";
import {StyleManager} from "InternalShared/PageBuilder/Controls/Core/styles/StyleManager";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {
    ControlTypeEnum,
    NormalPDFControlFactory, NormalPDFControlOptionsFactory,
} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {DragDropService, SectionOptionsEnum} from "InternalShared/PageBuilder/Services/DragDropService";
import {IPDFContainer} from "InternalShared/PageBuilder/Controls/Core/IPDFContainer";
import {GetControlOptions} from "InternalShared/Events/GetControlOptions";
import {GetControl} from "InternalShared/Events/GetControl";
import {PDFControlGenerator} from "InternalShared/PageBuilder/Controls/Core/Generators/PDFControlGenerator";
import {GroupManager} from "InternalShared/PageBuilder/DragAndDrop/GroupManager";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";
import {CurrencyUtils} from "PageBuilder/utils/CurrencyUtils";
import {DuplicateFieldEvent} from "InternalShared/Events/DuplicateFieldEvent";
import {KeyDownManager} from "InternalShared/PageBuilder/DragAndDrop/KeyDownManager";
import {ConfirmationDialog} from "shared/controls/Dialogs/premade/ConfirmationDialog/ConfirmationDialog";


library.add(faGoogleDrive as any);
library.add(faCog);


export class PDFDocument extends React.Component<PageProps,PageState> implements IPDFContainer{
    static defaultProps: Partial<PageProps> = {
        IsDragging:false
    };
    public $headerContainer:JQuery;
    public $contentContainer:JQuery;
    public $footerContainer:JQuery;
    private FooterDragManager:SectionDragManager;
    private HeaderDragManager:SectionDragManager;
    public pageIndex:number=-1;
    public $page:JQuery;
    public components:PDFControlBase[]=[];
    private $previewContainer:JQuery=null;
    public PageOptions:PDFDocumentOptions;
    public EnableMultiPage:boolean;
    public dragDropService:DragDropService;
    public PageService:PageService;
    public DocumentWorkArea:HTMLDivElement;
    public RootContainer:HTMLDivElement;
    public Form:FormDTO;
    @observable
    public TabsToOpen:string='';
    public CustomFields:{Name:string,Id:string}[];
    constructor(prop:any)
    {
        super(prop);
        this.CustomFields=[];
        this.state={TemplateSettingsIsOpen:false,Options:null};
        this.dragDropService=DragDropService.Instance();
        PageService.Instance().page=this;

        this.PageService=PageService.Instance();
        this.PageService.page=this;
        EventManager.Subscribe(ItemDeleted,item=>this.ItemDeleted(item.Item));
        EventManager.Subscribe(GetControlOptions,e=>{
            return NormalPDFControlOptionsFactory.GetControlOptions(e.Type);
        });

        EventManager.Subscribe(DuplicateFieldEvent,e=>this.DuplicateField(e.options,e.id));

        EventManager.Subscribe(GetControl,e=>{
            return NormalPDFControlFactory.GetControl(e.Type);
        });
    }

    public ForceRerender(){
        this.forceUpdate();
    }


    componentDidMount(){
        this.InitializeContextListener();
        GroupManager.Initialize(this);
        KeyDownManager.Initialize(this);
        window.addEventListener("resize", ()=> {
            this.AdjustSize()
        })
    }

    public Initialize(form:FormDTO,pageOptions:any)
    {
        this.Form=form;

        this.CustomFields=(rednaoVar as any).CustomFieldsList.filter(x=>x.FormId==this.Form.Id);
        if(this.Form==null)
        {
            this.Form={
                Id:'',
                Fields:[],
                Notifications:[]
            };
        }

        this.Form.Fields.push({
            Id:'_seq_num',
            Label:'Entry Id',
            SubType:'number',
            Type:'Text'
        });

        this.Form.Fields.push(
            {
                Id:'_creation_date',
                Label:'Creation Date',
                SubType:'date-time',
                Type:'Date'
            }
        );
        if(pageOptions==null) {
            this.PageOptions = new PDFDocumentOptions().Merge({FormId:form.Id});
            this.PageOptions.Pages.push(new PageOptions().Merge());
        }
        else {

            this.PageOptions=pageOptions;
        }

        CurrencyUtils.GetInstance().Config=this.PageOptions.DocumentSettings.CurrencySettings;

        this.EnableMultiPage=this.PageOptions.DocumentSettings.EnableMultiplePage;
        this.SetBaseStyles();
        StyleManager.SetStyle(this.PageOptions.Styles);

        this.setState({Options:this.PageOptions});

        this.$page=jQuery('.pdfPageContainer .pdfPage');
        this.$page.empty();
        this.CreateSections();
        this.HeaderDragManager=new SectionDragManager(this.$headerContainer,this,"bottom",this.$contentContainer);
        this.FooterDragManager=new SectionDragManager(this.$footerContainer,this,"top",this.$contentContainer);
        this.ShowPage(0);
        this.UpdateBackground();
        this.AdjustSectionSize();



    }

    GetSectionContainer(targetId:SectionOptionsEnum)
    {
        switch(targetId)
        {
            case "header":
                return this.$headerContainer;
            case "content":
                return this.$contentContainer;
            case "footer":
                return this.$footerContainer;
        }

        return null;
    }

    GetTargetSection(top: number,left) {
        if(this.SectionContainsPoint(this.$headerContainer[0] as any, top,left))
            return SectionOptionsEnum.header;

        if(this.SectionContainsPoint(this.$contentContainer[0] as any, top,left))
            return SectionOptionsEnum.content;

        if(this.SectionContainsPoint(this.$footerContainer[0] as any, top,left))
            return SectionOptionsEnum.footer;

        return null;
    }

    private SectionContainsPoint(section: HTMLDivElement, top: number,left:number) {
        let rect=section.getBoundingClientRect();

        let offsetTop=rect.top+document.documentElement.scrollTop;
        let offsetLeft=rect.left+document.documentElement.scrollLeft;
        return top>=offsetTop&&top<=offsetTop+rect.height&&left<offsetLeft+rect.width;
    }

    render(): React.ReactNode {
        return (

            <div ref={e=>{this.DocumentWorkArea=e;this.AdjustSize();}} id={'DocumentWorkArea'} className={'rednao'} style={{padding:'20px 0 0 20px',backgroundColor:'#6b6b6b',minHeight:'100%'}} tabIndex={0}>
                {this.EnableMultiPage &&
                <div>
                    <div style={{textAlign: 'left', paddingLeft: 20, userSelect: 'none'}}>
                        <i onClick={() => this.AddPage()} style={{fontSize: 20, cursor: 'pointer'}}
                           className="fa fa-plus-circle PageManagerItem"></i>
                        <i onClick={()=>this.GoPrevious()} style={{fontSize: 20,cursor: 'pointer'}}  className="fa fa-arrow-left PageManagerItem"></i>
                    <input className="form-control"
                           style={{width: 20,padding: 0,display: 'inline',margin: 0,textAlign:'center'}} type="text"
                           disabled={true} value={this.pageIndex+1}/>
                    <i onClick={()=>this.GoNext()} style={{fontSize: 20,cursor: 'pointer'}} className="fa fa-arrow-right PageManagerItem" aria-hidden="true"></i>
                        {this.pageIndex>0&&<i onClick={()=>this.RemovePage()} style={{fontSize: 20,cursor: 'pointer'}} className="fa fa-trash PageManagerItem" aria-hidden="true"></i>}
                    </div>
                    </div>

                }


        <div  className="pdfPageContainer" style={{fontSize:14,display: 'block',justifyContent:'center',fontFamily:"DejaVu Sans, Helvetica, sans-serif",fontWeight: 'normal',lineHeight: 'normal',textAlign:'center'}}>
            <div style={{display:'inline-block',transition:'200ms border-color ease-in-out',border:'5px solid',borderColor:this.props.IsDragging?'red':'transparent'}}>
                <div ref={e=>this.RootContainer=e} onDrop={e=>this.Drop(e)} onDragOver={e=>{e.preventDefault()}} className="pdfPage pdfBody" style={{transition:'200ms border-color ease-in-out', width:794, height:1123,backgroundColor:'white',display: 'inline-block',borderColor:this.props.IsDragging?'red':'#afafaf'}}>

                </div>
            </div>
        </div>
    </div>
        );
    }

    public AdjustSize(){
        if (null != this.DocumentWorkArea) {
            let e:HTMLDivElement = this.DocumentWorkArea.querySelector(".pdfPage");
            null != e && (this.DocumentWorkArea.style.minWidth = e.offsetWidth + 32 + "px")
        }
    }
    public ShowPage(pageIndex:number)
    {
        if(this.pageIndex>=0)
            this.PageOptions.Pages[this.pageIndex].Fields=this.components.map(x=>x.Options);
        this.components=[];
        this.pageIndex=pageIndex;
        let currentPage=this.PageOptions.Pages[pageIndex];
        this.$headerContainer.empty();
        this.$footerContainer.empty();
        this.$contentContainer.empty();
        this.$headerContainer.css('height',currentPage.HeaderSection.Height);
        this.$contentContainer.css('height',currentPage.ContentSection.Height);
        this.$footerContainer.css('height',currentPage.FooterSection.Height);
        this.InitializeFields(currentPage.Fields);
    }

    public GetPageOptionsToSave():PDFDocumentOptions{
       this.RearrangeComponents();

       this.PageOptions.Pages[this.pageIndex].Fields=this.components.map(x=>x.Options);
       this.PageOptions.Styles=StyleManager.StyleText;

      for(let page of this.PageOptions.Pages)
          for(let field of page.Fields)
              if(field.Type==ControlTypeEnum.Field.toString())
              {
                  let formField=this.Form.Fields.find(x=>x.Id==(field as FieldControlOptions).FieldId);
                  if(formField==null)
                    (field as FieldControlOptions).SubType='';
                  else
                      (field as FieldControlOptions).SubType=formField.SubType;
              }


       return this.PageOptions.ToObject();
    }

    public GetHtml(){
        /*if(this.$previewContainer==null) {
            this.$previewContainer=jQuery('<div style="display: none;position: absolute;"></div>');
            jQuery('body').append(this.$previewContainer);
        }else
            this.$previewContainer.empty();

        this.$previewContainer.append(this.GenerateArea(this.PageOptions.containerOptions.headerOptions,this.components.filter(x=>x.Options.targetId=="header")));
        this.$previewContainer.append(this.GenerateArea( this.PageOptions.containerOptions.contentOptions,this.components.filter(x=>x.Options.targetId=="content")));
        this.$previewContainer.append(this.GenerateArea( this.PageOptions.containerOptions.footerOptions,this.components.filter(x=>x.Options.targetId=="footer")));

        let html= `<html>
                    <head>
                        <style>
                            @font-face{
                                font-family:'FontAwesome';
                                src:url('@FONTAWESOME@');
                                }

                        
                            body{
                                font-family:'DejaVu Sans', Helvetica, sans-serif;
                                font-weight: normal;                                
                                font-size: 14px;
                            }
                            p{
                                line-height: 1em !important;
                                margin:0;
                                padding:0;
                            }
                            @page{
                                margin:0;
                            }                            
                        </style>`;


        html+=StyleManager.GetStylesText();

        html+=`
                    </head>
                    <body>${this.$previewContainer.html()}</body>
                </html>`;
        html=html.replace(/>/g,'> ');
        console.log(html);
        return html.replace(/\r?\n|\r/g,'');*/

        return '';
    }


    private GenerateArea(containerOptions: PageSectionOptions, runnableToolItemBases: PDFControlBase[]):JQuery {
        let $container:JQuery=jQuery('<div></div>');
        $container.css('height',containerOptions.height);
        $container.css('width',containerOptions.width);

        if(containerOptions.position=="documentFooter") {
            $container.css({'position': 'absolute', bottom: 0,'overflow':'hidden'});
        }
        else
            $container.css('position','relative');
        $container.addClass(containerOptions.position);
        runnableToolItemBases.forEach((element)=>$container.append(element.GetPDFHTMl()));
        return $container;
    }

    private InitializeContextListener() {
        (jQuery(document) as any).contextmenu((e)=>{
            let pdfElement=this.GetPDFElement(jQuery(e.target));
            if(pdfElement!=null) {
                pdfElement.ShowContext(e);
                return false;
            }

            if(this.DisableContext(jQuery(e.target)))
                return false;


        });
    }



    private DisableContext($target)
    {
        if($target.hasClass('pdfPage')||$target.hasClass('basicContextContainer'))
            return true;


        let $parent=$target.parent();
        if($parent.length>0)
            return this.DisableContext($parent);
        return false;
    }

    private GetPDFElement($target):PDFControlBase {
        if($target.hasClass('PDFElement'))
        {
            let elementId=$target.data('element-id');
            for(let element of this.components)
                if(element.Options.Id==elementId)
                    return element;
        }


        let $parent=$target.parent();
        if($parent.length>0)
            return this.GetPDFElement($parent);
        return null;
    }

    private ItemDeleted(target: PDFControlBase) {
        this.components.splice(this.components.indexOf(target),1);
    }

    private CreateSections() {
        this.$page.width(this.PageOptions.DocumentSettings.Width);
        this.$page.height(this.PageOptions.DocumentSettings.Height);
        this.$headerContainer=jQuery(`<div class="pdfHeader" style="width:${this.PageOptions.DocumentSettings.Width}px;position:relative;"></div>`);
        this.$contentContainer=jQuery(`<div class="pdfContent" style="width:${this.PageOptions.DocumentSettings.Width}px;;position:relative;"></div>`);
        this.$footerContainer=jQuery(`<div  class="pdfFooter" style="width:${this.PageOptions.DocumentSettings.Width}px;position:relative;"></div>`);

        this.$page.append(this.$headerContainer);
        this.$page.append(this.$contentContainer);
        this.$page.append(this.$footerContainer);
    }

    public async ChangePageSize(pageSize:PaperSize,orientation:"portrait"|"landscape") {
        if((pageSize.type==this.PageOptions.DocumentSettings.PageType&&this.PageOptions.DocumentSettings.Orientation==orientation))
            return;
        if(orientation=="landscape")
        {
            let oldSize=pageSize;
            pageSize=Object.assign({},pageSize);
            pageSize.width=oldSize.height;
            pageSize.height=oldSize.width;
        }



        this.PageOptions.DocumentSettings.PageType=pageSize.type as any;
        this.PageOptions.DocumentSettings.Height=pageSize.height;
        this.PageOptions.DocumentSettings.Width=pageSize.width;

        this.PageOptions.DocumentSettings.Orientation=orientation;
        this.AdjustSectionSize(false);

    }

    public async AdjustSectionSize(animate=true){
        if(animate)
            await this.$page.velocityAsync({opacity:0},200,'easeOutExp');
        if(this.EnableMultiPage!=this.PageOptions.DocumentSettings.EnableMultiplePage) {
            this.EnableMultiPage = this.PageOptions.DocumentSettings.EnableMultiplePage;
            this.ForceRerender();
        }
        this.$page.width(this.PageOptions.DocumentSettings.Width);
        this.$page.height(this.PageOptions.DocumentSettings.Height);
        this.$headerContainer.width(this.PageOptions.DocumentSettings.Width);
        this.$contentContainer.width(this.PageOptions.DocumentSettings.Width);
        this.$footerContainer.width(this.PageOptions.DocumentSettings.Width);

        if(this.PageOptions.DocumentSettings.HideFooter)
            this.$footerContainer.css('display','none');
        else
            this.$footerContainer.css('display','block');

        if(this.PageOptions.DocumentSettings.HideHeader)
            this.$headerContainer.css('display','none');
        else
            this.$headerContainer.css('display','block');

        for(let page of this.PageOptions.Pages)
        {
            let newContentHeight=this.PageOptions.DocumentSettings.Height;
            if(!this.PageOptions.DocumentSettings.HideHeader)
                newContentHeight-=page.HeaderSection.Height;

            if(!this.PageOptions.DocumentSettings.HideFooter)
                newContentHeight-=page.FooterSection.Height;

            page.ContentSection.Height=newContentHeight-1;
        }



        this.$contentContainer.height(this.PageOptions.Pages[this.pageIndex].ContentSection.Height);

        if(animate)
            this.$page.velocityAsync({opacity:1},200,'easeInExp');
        this.AdjustSize();
    }

    private InitializeFields(fieldOptions: PDFControlBaseOptions[]) {
        for(let fieldOption of fieldOptions)
        {
            let field=PDFControlGenerator.GetControl(this,fieldOption);
            this.components.push(field);
        }
    }

    private RearrangeComponents() {
        this.components=this.components.sort((a,b)=>{
            if(a.Options.TargetId!=b.Options.TargetId)
            {
                if(a.Options.TargetId=="header"||b.Options.TargetId=="footer")
                    return -1;
                if(a.Options.TargetId=="footer"||b.Options.TargetId=="header")
                    return 1;

            }


            let topA=parseInt(a.Options.Styles.Top);
            let topB=parseInt(b.Options.Styles.Top);
            if(topA<topB)
                return -1;
            if(topA>topB)
                return 1;

            return 0;
        });
    }

    UpdateSectionSize() {
        let headerSize=this.$headerContainer.outerHeight();
        let contentSize=this.$contentContainer.outerHeight();
        let footerSize=this.$footerContainer.outerHeight();

        contentSize+=headerSize+contentSize+footerSize-this.PageOptions.DocumentSettings.Height;

        this.PageOptions.Pages[this.pageIndex].HeaderSection.Height=headerSize;
        this.PageOptions.Pages[this.pageIndex].ContentSection.Height=contentSize;
        this.PageOptions.Pages[this.pageIndex].FooterSection.Height=footerSize;
    }

    AddPage() {
        this.PageOptions.Pages.push(

            new PageOptions().Merge({
                FooterSection: new SectionOption().Merge({Height: 100, Type: SectionOptionsEnum.footer}),
                ContentSection: new SectionOption().Merge({Height: 923, Type: SectionOptionsEnum.content}),
                HeaderSection: new SectionOption().Merge({Height: 100, Type: SectionOptionsEnum.header})
            }));

        this.ShowPage(this.PageOptions.Pages.length-1);
        this.forceUpdate();

    }

    GoNext(){
        if(this.PageOptions.Pages.length-1>this.pageIndex)
            this.ShowPage(this.pageIndex+1);
        this.forceUpdate();
    }

    GoPrevious(){

        if(this.pageIndex>0)
            this.ShowPage(this.pageIndex-1);
        this.forceUpdate();
    }

    async RemovePage() {
        if(await  ConfirmationDialog.Create('Are you sure?','Do you want to delete this page?').Show())
        {
            this.ShowPage(this.pageIndex-1);
            this.PageOptions.Pages.splice(this.pageIndex+1,1);
        }
        this.forceUpdate();
    }

    OpenSettings(tabToOpen:string='') {
        this.TabsToOpen=tabToOpen;
        this.setState({TemplateSettingsIsOpen:true});

    }

    private async Drop(e: React.DragEvent<HTMLDivElement>) {
        e.preventDefault();
        let type=e.dataTransfer.getData('Text');
        let field:PDFControlBase=PDFControlGenerator.GetControl(null,type);

        let pageX=e.pageX;
        let pageY=e.pageY;
        let target=this.GetTargetAndRelativeCoordinates(pageX,pageY);
        let result=await (field as PDFControlBase).InitializeWithTarget(this,target);
        if(result ==false)
            return;


        this.components.push(field);
    }


    private GetTargetAndRelativeCoordinates(pageX: number, pageY: number):{targetId:SectionOptionsEnum,x:number,y:number} {
        let page=this.$page[0] as HTMLElement;
        let bounding=page.getBoundingClientRect();
        let realLeft=Math.ceil(bounding.left+document.documentElement.scrollLeft);

        let coordinatesResult:{targetId:SectionOptionsEnum,x:number,y:number}={
            targetId:null,
            x:pageX- realLeft,
            y:0
        };

        let result:number;
        result=this.GetSectionsRelativeCoordinates(this.$headerContainer[0],pageY);
        if(result!==null)
        {
            coordinatesResult.targetId=SectionOptionsEnum.header;
            coordinatesResult.y=result;
        }

        result=this.GetSectionsRelativeCoordinates(this.$contentContainer[0],pageY);
        if(result!==null)
        {
            coordinatesResult.targetId=SectionOptionsEnum.content;
            coordinatesResult.y=result;
        }

        result=this.GetSectionsRelativeCoordinates(this.$footerContainer[0],pageY);
        if(result!==null)
        {
            coordinatesResult.targetId=SectionOptionsEnum.footer;
            coordinatesResult.y=result;
        }

        if(coordinatesResult.targetId===null)
            throw new Error('Invalid coordinates');

        return coordinatesResult;
    }

    public GetSectionsRelativeCoordinates(element:HTMLElement,y:number):number
    {
        let bounding=element.getBoundingClientRect();
        let absoluteTop=bounding.top+document.documentElement.scrollTop;

        if(absoluteTop<=y&&absoluteTop+bounding.height>=y)
            return y-absoluteTop;

        return null;

    }

    AfterTemplateSettingsChanged() {
        this.AdjustSectionSize();
    }

    UpdateBackground() {
        let styleManager=new StyleManager().CreateStyleClassManager('.pdfBody');
        styleManager.SetValue('background-image',this.PageOptions.DocumentSettings.BackgroundImageURL!=''?`url(${this.PageOptions.DocumentSettings.BackgroundImageURL});`:'');

        switch (this.PageOptions.DocumentSettings.BackgroundStyle) {
            case BackgroundStyleEnum.repeat:
                styleManager.SetValue('background-repeat','repeat');
                styleManager.SetValue('background-position','');
                styleManager.SetValue('background-size','');
                break;
            case BackgroundStyleEnum.top:
                styleManager.SetValue('background-repeat','no-repeat');
                styleManager.SetValue('background-position','center top');
                styleManager.SetValue('background-size','');
                break;
            case BackgroundStyleEnum.left:
                styleManager.SetValue('background-repeat','no-repeat');
                styleManager.SetValue('background-position','left center');
                styleManager.SetValue('background-size','');
                break;
            case BackgroundStyleEnum.right:
                styleManager.SetValue('background-repeat','no-repeat');
                styleManager.SetValue('background-position','right center');
                styleManager.SetValue('background-size','');
                break;
            case BackgroundStyleEnum.bottom:
                styleManager.SetValue('background-repeat','no-repeat');
                styleManager.SetValue('background-position','center bottom');
                styleManager.SetValue('background-size','');
                break;
            case BackgroundStyleEnum.center:
                styleManager.SetValue('background-repeat','no-repeat');
                styleManager.SetValue('background-position','center center');
                styleManager.SetValue('background-size','');
                break;
            case BackgroundStyleEnum.fill:
                styleManager.SetValue('background-repeat','no-repeat');
                styleManager.SetValue('background-position','center');
                styleManager.SetValue('background-size','100% 100%');
                break;

        }
    }

    private SetBaseStyles() {
        let baseStyles=`
          .PDFElement.Text p.alignleft{
                text-align:left;                    
             }
             .PDFElement.Text p.aligncenter{
                text-align:center;                    
             }
             .PDFElement.Text p.alignright{
                text-align:right;                    
             }
             
             .PDFElement.Text table{
                width:100%;
             }
        `;

        this.PageOptions.DocumentSettings.BaseStyles=baseStyles;

        let $style=jQuery(`<style type="text/css"></style>`);
        jQuery('body').append($style);
        $style.append(baseStyles);
    }

    private DuplicateField(options: PDFControlBaseOptions,originalId:number) {
        let field=PDFControlGenerator.GetControl(this,options);
        StyleManager.DuplicateStyle(originalId,field.Options.Id);
        this.components.push(field);
    }
}

interface PageProps{
    IsDragging:boolean;
}

interface PageState{
    TemplateSettingsIsOpen;
    Options:any;

}


